export function waasEntityOnboarding(lang){
    const laravel=`
    $url = 'https://sandbox.sasapay.app/api/v1/waas/entity-registration/';
    $data = [
        "BusinessName"=> "Miller Enterprises",
        "BusinessType"=> "Sole Proprietor",
        "KraPin"=> "*******",
        "BusinessRegNo"=> "*********",
        "CountryCode"=>"254",
        "MobileNumber"=> "***********",
        "Email"=> "jondoe@example.com",
        "MerchantCode"=> "*******",
        "ProposedAccountNumber"=>"*****",
        "CallbackUrl"=>"https://posthere.io/4bdd-47d5-a54d/callback/"
    ];
    
    $ch = curl_init($url);
    curl_setopt($ch, CURLOPT_POST, 1);
    curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    echo $response;

    `;
    const javascript=`
    const unirest = require('unirest');
    const req = unirest('POST', 'https://sandbox.sasapay.app/api/v1/waas/entity-registration/')
      .headers({
        'Content-Type': 'application/json'
      })
      .send(JSON.stringify({
        "BusinessName": "Miller Enterprises",
        "BusinessType": "Sole Proprietor",
        "KraPin": "***********",
        "BusinessRegNo": "*************",
        "CountryCode": "254",
        "MobileNumber": "*************",
        "Email": "johndoe@example.com",
        "MerchantCode": "*********",
        "ProposedAccountNumber": "************",
        "CallbackUrl": "https://posthere.io/4bdd-47d5-a54d/callback/"
      }))
      .end(function (res) { 
        if (res.error) throw new Error(res.error); 
        console.log(res.raw_body);
      });

    `
    const python=`
        import requests
        import json
        
        url = "https://sandbox.sasapay.app/api/v1/waas/entity-registration/"
        
        payload = json.dumps({
          "BusinessName": "Miller Enterprises",
          "BusinessType": "Sole Proprietor",
          "KraPin": "***********",
          "BusinessRegNo": "***********",
          "CountryCode": "254",
          "MobileNumber": "*************",
          "Email": "johndoe@example.com",
          "MerchantCode": "*********",
          "ProposedAccountNumber": "***********",
          "CallbackUrl": "https://posthere.io/4bdd-47d5-a54d/callback/"
        })
        headers = {
          'Content-Type': 'application/json'
        }
        response = requests.request("POST", url, headers=headers, data=payload)
        print(response.text)
    `
    const java=`
   OkHttpClient client = new OkHttpClient().newBuilder()
      .build();
    MediaType mediaType = MediaType.parse("application/json");
    RequestBody body = RequestBody.create(mediaType, "{\\n    \\"BusinessName\\": \\"Miller Enterprises\\",\\n    \\"BusinessType\\": \\"Sole Proprietor\\",\\n    \\"KraPin\\": \\"********\\",\\n    \\"BusinessRegNo\\": \\"KT1281148\\",\\n    \\"CountryCode\\": \\"254\\",\\n    \\"MobileNumber\\": \\"0790407191\\",\\n    \\"Email\\": \\"johndoe@example.com\\",\\n    \\"MerchantCode\\": \\"********\\",\\n    \\"ProposedAccountNumber\\":\\"**********\\",\\n    \\"CallbackUrl\\":\\"https://posthere.io/4bdd-47d5-a54d/callback/\\"\\n}");
    Request request = new Request.Builder()
      .url("https://sandbox.sasapay.app/api/v1/waas/entity-registration/")
      .method("POST", body)
      .addHeader("Content-Type", "application/json")
      .build();
    Response response = client.newCall(request).execute();
    `

    if (lang==='java') {
        return java
    } else if (lang==='python') {
        return python
    }else if (lang==='javascript') {
        return javascript
    } else {
        return laravel
    }
}
export function waasEntityOnboardingResponse() {
    return `
    {
      "statusCode": 0,
      "message": "Entity registered successfully ",
      "result": {
        "customer": {
          "display_name": "Simon Fintech",
          "mobile_number": "2547*******8"
        },
        "customer_account_number": "2****8-13",
        "customer_balance": "45.00",
        "cumulative_points": 0,
        "redeemed_points": 0,
        "available_points": 0,
        "cumulative_spent_amount": "0.00",
        "status": 1
      }
    }
    `
}
export function waasBeneficiaryOnboardingRequest(lang) {
    const laravel=`
    $url = 'https://sandbox.sasapay.app/api/v1/waas/customer-registration/';
    $data = [
       "MerchantCode"=>"2****8",
       "FirstName"=>"John",
       "MiddleName"=>"",
       "LastName"=>"Doe",
       "CountryCode"=>"254",
       "MobileNumber"=>"07*******280",
       "DocumentType"=>"1",
       "DocumentNumber"=>"1*******8",
       "Email"=>"john@example.com",
       "CallbackUrl"=>"https://example.com/4*****d/callback/"
    ];
    
    $ch = curl_init($url);
    curl_setopt($ch, CURLOPT_POST, 1);
    curl_setopt($ch, CURLOPT_POSTFIELDS, http_build_query($data));
    curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
    
    $response = curl_exec($ch);
    curl_close($ch);
    
    echo $response;

    `;
    const javascript=`
    const unirest = require('unirest');
    const req = unirest('POST', 'https://sandbox.sasapay.app/api/v1/waas/customer-registration/')
      .headers({
        'Content-Type': 'application/json'
      })
      .send(JSON.stringify({
           "MerchantCode":"2****8",
           "FirstName":"John",
           "MiddleName":"",
           "LastName":"Doe",
           "CountryCode":"254",
           "MobileNumber":"07*******280",
           "DocumentType":"1",
           "DocumentNumber":"1*******8",
           "Email":"john@example.com",
           "CallbackUrl":"https://example.com/4*****d/callback/"
      }))
      .end(function (res) { 
        if (res.error) throw new Error(res.error); 
        console.log(res.raw_body);
      });

    `
    const python=`
        import requests
        import json
        
        url = "https://sandbox.sasapay.app/api/v1/waas/customer-registration/"
        
        payload = json.dumps({
           "MerchantCode":"2****8",
           "FirstName":"John",
           "MiddleName":"",
           "LastName":"Doe",
           "CountryCode":"254",
           "MobileNumber":"07*******280",
           "DocumentType":"1",
           "DocumentNumber":"1*******8",
           "Email":"john@example.com",
           "CallbackUrl":"https://example.com/4*****d/callback/"
        })
        headers = {
          'Content-Type': 'application/json'
        }
        response = requests.request("POST", url, headers=headers, data=payload)
        print(response.text)
    `
    const java=`
        OkHttpClient client = new OkHttpClient().newBuilder()
          .build();
        MediaType mediaType = MediaType.parse("application/json");
        RequestBody body = RequestBody.create(mediaType, "{\\n    \\"MerchantCode\\": \\"****\\",\\n    \\"FirstName\\": \\"********\\",\\n    \\"MiddleName\\": \\"\\",\\n    \\"LastName\\": \\"******\\",\\n    \\"CountryCode\\": \\"254\\",\\n    \\"MobileNumber\\": \\"*********\\",\\n    \\"DocumentType\\": 1,\\n    \\"DocumentNumber\\": \\"31612788\\",\\n    \\"Email\\": \\"********\\",\\n    \\"CallbackUrl\\":\\"https://posthere.io/4bdd-47d5-a54d/callback/\\"\\n}");
        Request request = new Request.Builder()
          .url("https://sandbox.sasapay.app/api/v1/waas/customer-registration/")
          .method("POST", body)
          .addHeader("Content-Type", "application/json")
          .build();
        Response response = client.newCall(request).execute();
    `

    if (lang==='java') {
        return java
    } else if (lang==='python') {
        return python
    }else if (lang==='javascript') {
        return javascript
    } else {
        return laravel
    }
}
export function waasBeneficiaryOnboardingResponse() {
    return `
    {
    "statusCode": 0,
    "message": "Customer registered successfully ",
    "result": {
        "customer": {
            "display_name": "John K.  Doe",
            "mobile_number": "07*******8"
        },
        "customer_account_number": "2****8-13",
        "customer_balance": "45.00",
        "cumulative_points": 0,
        "redeemed_points": 0,
        "available_points": 0,
        "cumulative_spent_amount": "0.00",
        "status": 1
    }
}
    `
}